import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { CalendarDays, Copy, RefreshCw, Check } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function CalendarSyncCard() {
  const [url, setUrl] = useState(null);
  const [copied, setCopied] = useState(false);

  const generate = async () => {
    try {
      const r = await api.post("/calendar/token");
      setUrl(`${BACKEND_URL}/api/calendar/${r.data.token}.ics`);
      toast.success(url ? "Nouveau lien généré (l'ancien est désactivé)" : "Lien d'agenda généré");
    } catch { toast.error("Erreur"); }
  };
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); setCopied(true); setTimeout(() => setCopied(false), 1500); toast.success("Lien copié"); }
    catch { toast.error("Copie impossible"); }
  };

  return (
    <div className="mt-6 sc-card" data-testid="calendar-sync-card">
      <h2 className="text-lg font-bold text-slate-900 flex items-center gap-2"><CalendarDays className="w-5 h-5 text-indigo-500" /> Synchroniser mon agenda</h2>
      <p className="text-sm text-slate-600 mt-1">Vos séances confirmées dans Google Agenda, Apple Calendar ou Outlook (abonnement iCal, mise à jour automatique).</p>
      {!url ? (
        <button data-testid="ical-generate" onClick={generate} className="mt-3 sc-btn sc-btn-primary text-sm">Générer mon lien d'agenda</button>
      ) : (
        <div className="mt-3">
          <div className="flex gap-2 items-center">
            <input data-testid="ical-url" readOnly value={url} className="flex-1 border border-slate-200 rounded-xl p-2 text-xs bg-slate-50 font-mono" onFocus={(e) => e.target.select()} />
            <button data-testid="ical-copy" onClick={copy} className="sc-btn sc-btn-outline text-xs">{copied ? <Check className="w-4 h-4 text-emerald-600" /> : <Copy className="w-4 h-4" />}</button>
            <button data-testid="ical-rotate" onClick={generate} className="sc-btn sc-btn-outline text-xs" title="Régénérer"><RefreshCw className="w-4 h-4" /></button>
          </div>
          <div className="mt-2 flex flex-wrap gap-2 text-xs">
            <a data-testid="ical-google" href={`https://calendar.google.com/calendar/r?cid=${encodeURIComponent(url.replace(/^https?:/, "webcal:"))}`} target="_blank" rel="noreferrer" className="sc-btn sc-btn-outline text-xs">Ajouter à Google Agenda</a>
            <a data-testid="ical-apple" href={url.replace(/^https?:/, "webcal:")} className="sc-btn sc-btn-outline text-xs">Ajouter à Apple / Outlook</a>
          </div>
          <p className="mt-2 text-[11px] text-slate-500">Ce lien est personnel : ne le partagez pas. Régénérez-le pour révoquer l'ancien.</p>
        </div>
      )}
    </div>
  );
}
